var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c("section-title", { attrs: { icon: "mdi-office-building-marker" } }, [
        _vm._v("Datos de la sede")
      ]),
      _c(
        "v-card",
        { staticClass: "pa-4" },
        [
          _c(
            "v-form",
            { ref: "form", attrs: { "lazy-validation": "" } },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6" } },
                    [
                      _c("v-select", {
                        attrs: {
                          rules: [_vm.rules.required()],
                          label: "Lugar",
                          items: _vm.view.locations,
                          "item-text": "name",
                          "return-object": "",
                          required: "",
                          "prepend-icon": "mdi-map-marker",
                          loading: _vm.isFetchingData
                        },
                        model: {
                          value: _vm.selectedLocation,
                          callback: function($$v) {
                            _vm.selectedLocation = $$v
                          },
                          expression: "selectedLocation"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6" } },
                    [
                      _c("v-select", {
                        attrs: {
                          "no-data-text": "Se debe seleccionar un lugar",
                          rules: [_vm.rules.required()],
                          "item-text": "building.name",
                          items: _vm.availableDatacenters,
                          "return-object": "",
                          label: "Data Center",
                          required: "",
                          "prepend-icon": "mdi-office-building-marker-outline",
                          loading: _vm.isFetchingData
                        },
                        model: {
                          value: _vm.selectedDatacenter,
                          callback: function($$v) {
                            _vm.selectedDatacenter = $$v
                          },
                          expression: "selectedDatacenter"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6" } },
                    [
                      _c(
                        "v-menu",
                        {
                          attrs: {
                            "nudge-right": 40,
                            transition: "scale-transition",
                            "offset-y": "",
                            "max-width": "290px",
                            "min-width": "290px"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function(ref) {
                                var on = ref.on
                                return [
                                  _c(
                                    "v-text-field",
                                    _vm._g(
                                      {
                                        attrs: {
                                          label: "Fecha",
                                          readonly: "",
                                          rules: [_vm.rules.required()],
                                          "prepend-icon": "mdi-calendar"
                                        },
                                        model: {
                                          value: _vm.date,
                                          callback: function($$v) {
                                            _vm.date = $$v
                                          },
                                          expression: "date"
                                        }
                                      },
                                      on
                                    )
                                  )
                                ]
                              }
                            }
                          ]),
                          model: {
                            value: _vm.dateMenu,
                            callback: function($$v) {
                              _vm.dateMenu = $$v
                            },
                            expression: "dateMenu"
                          }
                        },
                        [
                          _c("v-date-picker", {
                            attrs: {
                              locale: "es",
                              color: "#60BB46",
                              max: new Date().toISOString().substr(0, 10),
                              "header-color": "rgb(64,139,56)",
                              "no-title": ""
                            },
                            on: {
                              input: function($event) {
                                return _vm.dateInputted($event)
                              }
                            },
                            model: {
                              value: _vm.pickerDate,
                              callback: function($$v) {
                                _vm.pickerDate = $$v
                              },
                              expression: "pickerDate"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Hora",
                          rules: [_vm.rules.required()],
                          type: "time",
                          required: "",
                          "prepend-icon": "mdi-clock-outline"
                        },
                        model: {
                          value: _vm.hour,
                          callback: function($$v) {
                            _vm.hour = $$v
                          },
                          expression: "hour"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-fade-transition",
        [
          _vm.selectedDatacenter
            ? _c("register-availability-form", {
                attrs: {
                  "building-equipments":
                    _vm.selectedDatacenter.buildingEquipments,
                  "is-loading": _vm.isLoading
                },
                on: {
                  "update:buildingEquipments": function($event) {
                    return _vm.$set(
                      _vm.selectedDatacenter,
                      "buildingEquipments",
                      $event
                    )
                  },
                  "update:building-equipments": function($event) {
                    return _vm.$set(
                      _vm.selectedDatacenter,
                      "buildingEquipments",
                      $event
                    )
                  },
                  register: _vm.register
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }